import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param field Complete form
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function oneInputNotEmptyValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let oneInputNotEmpty = false;
  let msg: string = '';
  if (!model) {
    return null;
  }

  // Options checkbox parameter 
  // List of checkbox name "substrings" to check for "at least one true"

  try {
    // Iterate through the model to check if at least one option is true
    const mod = Object.entries(model);

    for (let item of mod) {

      if (oneInputNotEmpty === true)
        break;

      const item_name = item[0];
      const item_value = item[1];

      // Option service is a input. If it is No, we don't need to check the rest
      //   The validation will pass
      if (options.centinel && options.centinel && item_name === options.centinel) {
        if (item_value === 'No') {
          // Validation succeeds. If service is No, we don't need to check at least one
          return null;
        }
      }

      if (options.inputs !== undefined && Array.isArray(options.inputs)) {
        for (let fieldNamePart of options.inputs) {
          if (item_name.includes(fieldNamePart)) {
            if (item_value) {
              oneInputNotEmpty = true;
              break;
            }
          }
        }
      }
    }
  } catch (err) {
    console.warn("oneInputNotEmpty Exception " + err);
  }

  if (!oneInputNotEmpty) {
    msg = "At least one entry should be required";
  }
  return !msg
    ? null
    : {
      "oneInputNotEmpty": {
        message: msg,
        errorPath: options.centinel
      }
    }

}

